import { render } from "./OptionsContacts.vue?vue&type=template&id=f01ac3ec"
import script from "./OptionsContacts.vue?vue&type=script&lang=js"
export * from "./OptionsContacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__